<template>
    <div @click="$emit('click')" class="button">
        <span class="modifier">+ {{mod}}</span>
        <span>{{label}}</span>
    </div>
</template>

<script>
    export default {
        props: ["label", "mod"],
        data() {
            return {};
        }
    };
</script>

<style scoped>
    .button {
        border-radius: 40px;
        background: #f2f2f2;
box-shadow:  5px 5px 10px #acacac, 
             -5px -5px 10px #ffffff;
        margin: 10px;
        color: #004369;
        padding: 10px;
        cursor: pointer;
        display: grid;
        grid-template-columns: 80px 1fr 70px;
    }

    .modifier {
        margin-right: 20px;
        color: #006AA6;
    }
</style>